import { Inject, Injectable } from '@angular/core';
import { ASSET_MAP } from '@rd/core/tokens/rd-lib.token';

type AssetMapItem = Record<
  string,
  {
    name: string;
    hashedName: string;
    extension: string;
    path: {
      originalPath: string;
      hashedPath: string;
    };
  }
>;

export type AssetMap = {
  images: AssetMapItem;
  icons: AssetMapItem;
  i18n: AssetMapItem;
};

export enum AssetType {
  Image = 'images',
  Icon = 'icons',
  I18n = 'i18n',
}

@Injectable({ providedIn: 'root' })
export class AssetService {
  constructor(@Inject(ASSET_MAP) public assetMap: AssetMap) {}

  getAssetPath(name: string, type: AssetType): string {
    if (!this.assetMap || !this.assetMap[type]) {
      return '';
    }
    switch (type) {
      case AssetType.Icon:
        return this.getIconPath(name);
      case AssetType.Image:
        return this.getImagePath(name);
      case AssetType.I18n:
        return this.getI18nPath(name);
      default:
        return '';
    }
  }

  getIconPath(name: string): string {
    const assetName = 'icon-' + name + '.svg';
    return '/' + this.assetMap.icons[assetName].path.hashedPath;
  }

  getImagePath(name: string): string {
    return '/assets/' + this.assetMap.images[name].path.hashedPath;
  }

  getI18nPath(name: string): string {
    return '/assets/' + this.assetMap.i18n[name].path.hashedPath;
  }
}
